module.exports = __webpack_public_path__ + "img/Adline C Clarke.2913ad95.jpg";